import { render, staticRenderFns } from "./CoverPage.vue?vue&type=template&id=437d3779&scoped=true&"
import script from "./CoverPage.vue?vue&type=script&lang=js&"
export * from "./CoverPage.vue?vue&type=script&lang=js&"
import style0 from "./CoverPage.vue?vue&type=style&index=0&id=437d3779&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437d3779",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437d3779')) {
      api.createRecord('437d3779', component.options)
    } else {
      api.reload('437d3779', component.options)
    }
    module.hot.accept("./CoverPage.vue?vue&type=template&id=437d3779&scoped=true&", function () {
      api.rerender('437d3779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/proposal-renderer/CoverPage.vue"
export default component.exports